import { Map } from 'immutable';

export const getRoot = state => state.get('shade') || Map();

export const getShadeData = state => getRoot(state).get('data') || [];
